import { useTheme } from 'styled-components'

import { CategoryTileContainer, CategoryTileImage } from '@/components/brp/styled'
import { LinkCustom } from '@/components/shared/link-custom/LinkCustom'
import { BodyText } from '@/ui/atoms/body-text'
import { Spacing } from '@/ui/atoms/spacing'

export type CategoryTileProps = {
  /**
   * Display label for the category
   */
  label: string
  /**
   * Display description for the category
   */
  description: string
  /**
   * Image source
   */
  imageSrc: string
  /**
   * Navigation URL
   */
  url: string
  /**
   * Function triggered on tile click
   */
  onClick: (tileLabel: string) => void
}

export const CategoryTile = ({ label, description, imageSrc, url, onClick }: CategoryTileProps) => {
  const { spacing, colors } = useTheme()

  const handleClick = () => {
    onClick(label)
  }

  return (
    <LinkCustom href={url} noStyle isFullWidth onClick={handleClick}>
      <CategoryTileContainer>
        <CategoryTileImage srcImage={{ src: imageSrc }} alt={description} skipNextImage />
        <Spacing pTop={spacing.default} pBottom={spacing.default}>
          <Spacing mBottom={spacing.mini}>
            <BodyText weight="medium" textAlign="center" color={colors.white}>
              {label}
            </BodyText>
          </Spacing>
          <BodyText size="small" textAlign="center" color={colors.purple.light4}>
            {description}
          </BodyText>
        </Spacing>
      </CategoryTileContainer>
    </LinkCustom>
  )
}
